import React from 'react';
import { withStyles } from '@material-ui/styles';
import styles from './styles';
import clsx from 'clsx';

const Anchor = ({ classes, anchor = 'down' }) => (
  <svg
    className={clsx(classes.anchorRoot, classes[anchor])}
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="20"
    height="20"
    viewBox="0 0 32 32"
    aria-hidden="true"
  >
    <title>{anchor}</title>
    <path d="M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"></path>
  </svg>
);

export default withStyles(styles)(Anchor);
